import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

// Components
import CustomModal from 'components/CustomModal';
import InputField from 'components/Fields/InputFields/InputField';
import CheckBoxField from 'components/Fields/CheckBoxField';
import InputTextArea from 'components/Fields/InputFields/InputTextArea';

// Styles
import * as modalStyle from 'components/CustomModal/styles';
import s from './MessagesModal.style';


const MessageTypesModal = (props) => {
  const { t, isOpen, onClose, job } = props;

  const sms = job && job.smsSettings;
  const push = job && job.pushSettings;

  return (
    <CustomModal isOpen={isOpen}
      onRequestClose={onClose}
      style={{ content: { maxWidth: '45em', padding: 0, maxHeight: '95vh' } }}
    >
      <modalStyle.CommonModalWrapper>
        {/* ──── Header ──────────────────────────────────────────────────────────────── */}
        <modalStyle.ModalBlockSection className="header-wrapper">
          <modalStyle.ModalCloseIcon className="close-icon" onClick={onClose} />
          <modalStyle.ModalTitle>{t('modal_mass_message_caption')}</modalStyle.ModalTitle>
        </modalStyle.ModalBlockSection>

        {/* ──── Content ────────────────────────────────────────────────────────────────── */}
        <s.MessageTypesContentWrapper>

          {/* ──── Checked types ─────────────────────────────────────────────────────────── */}
          <modalStyle.ModalBlockSection borderBottom>
            <p className="section-title">{t('modal_mass_message_types_label')}</p>

            <div className="message-types-row">
              <CheckBoxField
                rightLabel={t('modal_mass_message_type_sms')}
                input={{
                  checked: sms && sms.isActive,
                  name: 'sms',
                  value: sms && sms.isActive,
                  readOnly: true
                }} />

              <CheckBoxField
                rightLabel={t('modal_mass_message_type_push')}
                input={{
                  checked: push && push.isActive,
                  name: 'push',
                  value: push && push.isActive,
                  readOnly: true
                }} />

              <CheckBoxField
                rightLabel={t('modal_mass_message_type_email')}
                input={{
                  disabled: true,
                  name: 'email',
                }} />

            </div>
          </modalStyle.ModalBlockSection>

          <div className="scrolled">

            {/* ──── SMS  ─────────────────────────────────────────────────────────── */}

            {sms && sms.isActive && sms.message ?
              <modalStyle.ModalBlockSection className="border-bottom">
                <p className="section-title">{t('modal_mass_message_sms_caption')}</p>

                <div className="input-el-row">
                  <InputTextArea
                    label={t('modal_mass_message_sms_text')}
                    input={{
                      readOnly: true,
                      name: 'smsMessage',
                      value: sms.message,
                    }}
                  />
                </div>
              </modalStyle.ModalBlockSection>
              : null
            }


            {/* ──── Push  ─────────────────────────────────────────────────────────── */}
            {push && push.isActive ? <modalStyle.ModalBlockSection className="border-bottom">

              <p className="section-title">{t('modal_mass_message_push_caption')}</p>

              {push.title ?
                <div className="input-el-row">
                  <InputField
                    label={t('modal_mass_message_push_title')}
                    input={{
                      readOnly: true,
                      name: 'pushTitle',
                      value: push.title,
                    }} />
                </div>
                : null
              }

              {push.message ? <div className="input-el-row">
                <InputTextArea
                  isRequired
                  label={t('modal_mass_message_push_message')}
                  input={{
                    readOnly: true,
                    name: 'pushMessage',
                    value: push.message,
                  }}
                />
              </div>
                : null}
            </modalStyle.ModalBlockSection>
              : null}

          </div>


          {/* ──── Footer ───────────────────────────────────────────────────────────────── */}

          <modalStyle.ModalFooter className="footer" topBorder>
            <modalStyle.ModalFooterBtn
              type='button'
              onClick={onClose}>
              {t('push_modal_close_button')}
            </modalStyle.ModalFooterBtn>
          </modalStyle.ModalFooter>

        </s.MessageTypesContentWrapper>

      </modalStyle.CommonModalWrapper>

    </CustomModal>
  );
};
MessageTypesModal.propTypes = {
  t: PropTypes.func.isRequired
};

export default translate()(MessageTypesModal);
